import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 120000,
  headers: {
    "Bypass-Tunnel-Reminder": "true"
  }
});

export const api = {
  // Itineraries
  generateItinerary: (data) => client.post("/itineraries/generate", data).then((r) => r.data),
  listItineraries: () => client.get("/itineraries").then((r) => r.data),
  getItinerary: (id) => client.get(`/itineraries/${id}`).then((r) => r.data),
  updateItinerary: (id, data) => client.put(`/itineraries/${id}`, data).then((r) => r.data),
  deleteItinerary: (id) => client.delete(`/itineraries/${id}`).then((r) => r.data),
  regenerateDay: (id, payload) => client.post(`/itineraries/${id}/regenerate-day`, payload).then((r) => r.data),
  uploadHotelImage: (id, file, label) => {
    const fd = new FormData();
    fd.append("file", file);
    if (label) fd.append("label", label);
    return client.post(`/itineraries/${id}/hotel-images`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  parseVendorItinerary: (file, customerData) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("customer_name", customerData.customer_name);
    if (customerData.customer_contact) fd.append("customer_contact", customerData.customer_contact);
    if (customerData.customer_email) fd.append("customer_email", customerData.customer_email);
    if (customerData.travelers_adults !== undefined) fd.append("travelers_adults", customerData.travelers_adults);
    if (customerData.travelers_children !== undefined) fd.append("travelers_children", customerData.travelers_children);
    if (customerData.travelers_infants !== undefined) fd.append("travelers_infants", customerData.travelers_infants);
    if (customerData.packages && customerData.packages.length > 0) {
      fd.append("packages_json", JSON.stringify(customerData.packages));
    }
    return client.post("/itineraries/parse-vendor", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  analyzeReceipt: (itineraryId, file, context = "") => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("context", context);
    return client.post(`/itineraries/${itineraryId}/analyze-receipt`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(r => r.data);
  },
  pdfUrl: (id) => `${API}/itineraries/${id}/pdf`,
  generateShareLink: (id, days) => client.post(`/itineraries/${id}/share?days=${days}`).then(r => r.data),
  getSharedItinerary: (token) => client.get(`/share/${token}`).then(r => r.data),

  // Images
  searchImages: (query, per_page = 12) => client.post("/images/search", { query, per_page }).then((r) => r.data),

  // Hotels
  searchHotels: (location) => client.get(`/hotels/search?location=${encodeURIComponent(location)}`).then((r) => r.data),
  getHotels: () => client.get("/hotels").then((r) => r.data),
  saveHotel: (data) => client.post("/hotels", data).then((r) => r.data),
  deleteHotel: (id) => client.delete(`/hotels/${id}`).then((r) => r.data),

  // Packages
  generatePackage: (file, context = "") => {
    const fd = new FormData();
    if (file) fd.append("file", file);
    if (context) fd.append("context", context);
    return client.post("/tour-packages/generate", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  listPackages: (params = {}) => client.get("/tour-packages", { params }).then((r) => r.data),
  getPackage: (id) => client.get(`/tour-packages/${id}`).then((r) => r.data),
  createPackage: (data) => client.post("/tour-packages", data).then((r) => r.data),
  updatePackage: (id, data) => client.put(`/tour-packages/${id}`, data).then((r) => r.data),
  deletePackage: (id) => client.delete(`/tour-packages/${id}`).then((r) => r.data),

  // Inquiries
  createInquiry: (data) => client.post("/inquiries", data).then((r) => r.data),
  listInquiries: () => client.get("/inquiries").then((r) => r.data),

  // Stats & Accounting
  adminStats: () => client.get("/admin/stats").then((r) => r.data),
  getAccountingReports: (params = {}) => client.get("/accounting/reports", { params }).then((r) => r.data),
  addLedgerTransaction: (data) => client.post("/accounting/ledger", data).then((r) => r.data),
  updateLedgerTransaction: (id, data) => client.put(`/accounting/ledger/${id}`, data).then((r) => r.data),
  deleteLedgerTransaction: (id) => client.delete(`/accounting/ledger/${id}`).then((r) => r.data),
};

export default api;
